import QRCode from "react-qr-code";
import React, {useState} from 'react'

// const appName = "时间记录软件";
const appName = "为之时间";
// const downloadUrl =
//     "http://download.timetr.cn/timetr.apk";
const downloadUrl =
    "http://download.timetr.cn/wztime.apk";

function App() {

    //移动端屏幕
    const isMobile = window.innerWidth < window.innerHeight;

    console.log("isMobile", isMobile);

    return (
        isMobile ? <MobileDownloadPage/> : <DesktopDownloadPage/>
    );
}

function DesktopDownloadPage() {

    const [showHwQRCode, setShowHwQRCode] = useState(false);
    const hideHWQRCodeClassName = "bg-white rounded-[24px] w-[228px] h-[228px] p-[34px] absolute right-[215px] bottom-[45px] shadow-2xl hidden";
    const showHWQRCodeClassName = "bg-white rounded-[24px] w-[228px] h-[228px] p-[34px] absolute right-[215px] bottom-[45px] shadow-2xl";

    const handleMouseEnter = () => {
        setShowHwQRCode(true);
    };

    const handleMouseLeave = () => {
        setShowHwQRCode(false);
    };

    return (
        <div
            className="bg-gradient-to-r from-blue-500 to-cyan-500 max-w-screen h-screen flex min-w-[1080px] min-h-[700px]">
            <div className="m-auto relative">
                <div className="flex flex-col w-[1031px] h-[698px]">
                    <div className="bg-white rounded-[40px] flex flex-row w-full h-full ">
                        <div className="w-1/2 bg-[#f1f1f1] rounded-l-[40px] flex flex-col justify-center">
                            <div className="flex flex-col items-center">
                                <div className="flex">
                                    <img
                                        className="w-[36px] h-[36px]"
                                        src="/logo216.png"
                                        alt="时间记录logo"
                                    />
                                    <h1 className="text-black text-xl font-semibold ml-[17px] my-auto">
                                        {appName}
                                    </h1>
                                </div>
                                <h2 className="text-neutral-800 text-xl font-semibold mt-[31px]">
                                    记录时间
                                </h2>
                                <p className="w-[392px] text-center text-neutral-500 text-base font-normal mt-[10px]">
                                    想让生活、学习变得更有掌控感、更可知？那就快来使用{appName}吧
                                </p>
                                <div className="bg-white rounded-[24px] w-[228px] h-[228px] my-[31px] p-[34px]">
                                    <QRCode className="w-full h-full" value={downloadUrl}/>
                                </div>
                                <span className="block">或</span>
                                <a
                                    className="text-neutral-400 text-lg font-normal mt-[20px] underline decoration-1"
                                    href={downloadUrl}
                                    target="_blank"
                                >
                                    直接下载
                                </a>
                            </div>
                        </div>
                        <div className="w-1/2 flex">
                            <img
                                className="m-auto w-[245px] h-[496px]"
                                alt="时间记录截图"
                                src="/app_screen2.png"
                            />
                        </div>
                    </div>
                    <div className="m-auto mt-[31px] flex flex-row items-center">
                        <p className=" text-[#EDEDED] text-base font-normal">
                            <a
                                href="https://beian.miit.gov.cn/"
                                target="_blank"
                            >
                                网站备案号:蜀ICP备2023003834号-1 APP备案号:蜀ICP备2023003834号-3A
                            </a>
                        </p>
                    </div>
                </div>
                <div className={showHwQRCode ? showHWQRCodeClassName : hideHWQRCodeClassName}>
                    <QRCode className="w-full h-full" value={downloadUrl}/>
                </div>
            </div>
        </div>
    );
}

function MobileDownloadPage() {
    //移动端像素要除以3，比如说移动端的window.innerHeight=649，实际屏幕尺寸是1920。
    return (
        <>
            <div style={{height: '323px', backgroundColor: '#FAFAFA'}}>
                <div style={{paddingTop: "16px",paddingBottom: "16px"}}>
                    <img
                        style={{display: "inline",marginLeft:"28px",marginRight:"18px"}}
                        className="w-[25px] h-[25px]"
                        src="/logo216.png"
                        alt="时间记录logo"
                    />
                    <h1 style={{display: "inline",fontSize:"13.3px",color:"#484848"}}>{appName}</h1>
                </div>
                <div>
                    <h2 style={{fontSize:"24px",marginTop:"38px",textAlign:"center",fontWeight:"bold",color:"black"}}>记录时间</h2>
                    <div className='flex items-center justify-center'>
                        <p style={{width:"293px",textAlign:"center",fontSize:"13.3px",marginTop:"31px",marginBottom:"31px",color:"#484848"}}>想让生活、学习变得更有掌控感、更可知？那就快来使用{appName}吧</p>
                    </div>
                    <div className='flex items-center justify-center'>
                        <a href={downloadUrl}
                           target="_blank"
                           style={{display: "flex", alignItems: "center", justifyContent: "center",textAlign:"center",backgroundColor:"#2D64F5",height:"45px",width:"171px",borderRadius:"45px"}}>
                            <img style={{display:"inline",verticalAlign:"baseline"}} className="w-[15px] h-[15px]" src="/assets/icon_download_app.png" alt="下载图标"/>
                            <span style={{display:"inline",color:"white",fontSize:"13.3px",marginLeft:"10px"}}>立即下载</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className='flex items-center justify-center' style={{height: '455px',backgroundColor: 'white'}}>
                <img
                    className="m-auto w-[149px] h-[302px]"
                    alt="时间记录截图"
                    src="/app_screen2.png"
                />
            </div>
            <div style={{height:"50px",color:"#FBFBFB",borderTop:"1px solid #F2F2F2",fontSize:"8px",paddingLeft:"13px",paddingRight:"13px"}}>
                <div style={{marginTop:"12px"}}>
                    <p style={{color:"#353535",float:"left"}}>四川为之科技有限责任公司</p>
                    <a style={{color:"#353535",float:"right"}} href="https://beian.miit.gov.cn/" target="_blank">网站备案号:蜀ICP备2023003834号-1<br/>APP备案号:蜀ICP备2023003834号-3A</a>
                </div>
            </div>
        </>
    );
}

export default App;
